// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__3AXOC","select":"Header_select__1cLV8","clinic":"Header_clinic__1nWpD"};